module.exports = __webpack_public_path__ + "static/img/QQ@2x.4e948cde.png";